import feedbackAPI from '@shared/api/shared/feedback'
import _debounce from 'lodash/debounce'

export default {
  data: function () {
    return {
      feedback: {
        feedbackID: null,
        emailCollected: false,
        interactions: [],
        answer: {
          items: {
            // Format can be found in mixins/genericContentItemAnswer.js
          },
          itemsList: [],
        },
      },
    }
  },
  methods: {
    initializeVisitor: function () {
      if (this.feedback.feedbackID !== null || this._initializingVisitor) {
        return
      }
      this._initializingVisitor = true

      // Only use when in widgetScript
      if (process.env.PROJECT === 'scriptGenerator') {
        return feedbackAPI
          .confirmHandshake(this.backendURL, {
            widgetID: this.widget.id,
            page: window.location.href,
            visitorInfo: this.visitorInfo ? this.visitorInfo : null,
          })
          .then((response) => {
            this.feedback.feedbackID = response.data
          })
          .catch((error) => {
            console.log(error)
            console.log('%cThere was a problem with displaying your widget',
              'color:red')
          })
          .finally(() => {
            this._initializingVisitor = false
          })
      }
    },
    saveFeedback: _debounce(function (data) {
      // Only use when in widgetScript
      if (process.env.PROJECT === 'scriptGenerator') {
        return feedbackAPI
          .saveFeedback(this.backendURL, data)
          .then((response) => {})
          .catch((error) => {
            console.log('%cThere was a problem with saving your feedback',
              'color:red')
            console.log(error)
          })
      }
    }, 750),
    waitForValidation(validation) {
      return new Promise((resolve) => {
        // If $pending is undefined or false, resolve immediately
        if (!validation.$pending) {
          resolve()
          return
        }
        // Watch for changes in $pending
        const unwatch = this.$watch(
          () => validation.$pending,
          (pending) => {
            if (!pending) {
              unwatch()
              resolve()
            }
          },
        )
      })
    },
    async triggerFeedback(data) {
      //  - check if exists in itemsList
      //  - update in answers if already exists
      //  - add to answers & itemsList if doesn't exist

      // Update validation list with latest values
      this.triggerUpdateValidationList(data)

      const validationIndex = this.getValidationIndex(data.id)

      // Don't save input unless it is valid
      if (validationIndex !== -1) {
        this.$v.inputsToBeValidated.$each.$iter[validationIndex].$touch()
        const inputValidation = this.$v.inputsToBeValidated.$each.$iter[validationIndex]

        await this.waitForValidation(inputValidation)

        if (inputValidation.$error) {
          return
        }
      }

      if (data.subType === 'email') {
        this.feedback.emailCollected = true
        this.feedback.email = data.value
      }

      this.feedback.answer.items[data.id] = data
      // Append step ID
      this.feedback.answer.items[data.id].stepID = this.targetStepID

      // Set value 'answer' on component
      this.setComponentAnswer(data)

      // Avoid duplicate ids in itemsList
      if (!this.feedback.answer.itemsList.includes(data.id)) {
        this.feedback.answer.itemsList.push(data.id)
      }

      // Only use when in widgetScript
      if (process.env.PROJECT === 'scriptGenerator') {
        this.saveFeedback(this.feedback)
      }
    },
    setComponentAnswer: function (data) {

      const targetStep = this.widget.steps.find((step) => {
        return step.id === data.stepID
      })

      const targetContentItem = targetStep?.contentItems?.find(
        (contentItem) => { return contentItem.id === data.id })

      this.$set(targetContentItem, 'answer',
        { value: data.value, optionID: data.optionID })
    },
    hoverWidget: function () {
      if (!this.feedback.interactions.includes('hovered')) {
        this.feedback.interactions.push('hovered')
        this.saveFeedback(this.feedback)
      }
    },
  },
}
